<template>
  <div class="misc-wrapper">
    <b-link class="brand-logo">
      <vuexy-logo />
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          You are not authorized! 🔐
        </h2>
        <p class="mb-2">
          You don’t have permission to access this page. Sign in with an account that does.
        </p>
        <b-button variant="primary" class="mb-1 btn-sm-block" @click="logout">Sign out and go to login</b-button>
        <b-img fluid :src="imgUrl" alt="Not authorized page" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { BLink, BImg, BButton } from 'bootstrap-vue';
import VuexyLogo from '@core/layouts/components/Logo.vue';
import store from '@/store/index';
import useJwt from '@/auth/jwt/useJwt';

export default {
  components: {
    BLink,
    BImg,
    BButton,
    VuexyLogo,
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/not-authorized.svg'),
    };
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/not-authorized-dark.svg');
        return this.downImg;
      }
      return this.downImg;
    },
  },
  methods: {
    // A user lands here when no landing page is open to them, so "Back to
    // Home" only bounced straight back. Ending the session is the one exit
    // that always works: it also clears userPerms and any impersonation
    // state, which the navbar logout leaves behind.
    logout() {
      const { jwtConfig } = useJwt;
      [
        jwtConfig.storageTokenKeyName,
        jwtConfig.storageRefreshTokenKeyName,
        jwtConfig.storageTokenExpiryKeyName,
        jwtConfig.storageTokenSetTimeName,
        'userData',
        'userPerms',
        'adminSession',
      ].forEach((key) => localStorage.removeItem(key));
      this.$router.push({ name: 'auth-login' });
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
